import { render, staticRenderFns } from "./laboratoriosIndex.vue?vue&type=template&id=5ca60064&"
import script from "./laboratoriosIndex.vue?vue&type=script&lang=js&"
export * from "./laboratoriosIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports